/**
 * @name parsePercentage
 * @description Works like parseInt, except for strings that represent a percentage
 */
export const parsePercentage = (string: string): number =>
  parseInt(string.replace('%', ''), 10);
